<div class="row">
    <div class="col-md-12">
      <nb-card>
        <nb-card-header>
          Terms & Conditions
        </nb-card-header>
        <nb-card-body>
          <form [formGroup]="TermsConditions" class="form-container">   
            <div class="row">
              <div class="col-sm-3 col-md-12 col-md-8 mx-auto">
                <div class="form-group">
                  <label for="title" class="label " style="font-weight:bold">Content</label>
                  <textarea
                     nbInput
                      fullWidth
                      formControlName="Content"
                   rows="10"
                  maxlength="max"
                 fieldSize="small"
                 [status]="(submitted && f.Content.errors) ? 'danger' : 'basic'"
                  placeholder=""
                  style="resize: vertical;  min-height: 100px;">
                </textarea>
                <ng-container *ngIf="submitted && f.Content.errors" class="invalid-feedback">
                  <p class="caption status-danger" *ngIf="f.Content.errors.required">
                    Content is required
                  </p>
                </ng-container>
              </div>
              </div>
            </div>
            
            <div class="buttons-row d-flex justify-content-center">
              <button type="button" (click)="onSubmit()" class="appearance-filled" [size]="'small'"
                [status]="'success'" nbButton  [class.disabledBtn]="loading || TermsConditions.invalid">
                <nb-icon nbPrefix class="fa fa-spinner fa-spin"
                  *ngIf="loading" 
                pack="font-awesome"></nb-icon>Submit
              </button>
            </div>
          </form>
        </nb-card-body>
      </nb-card>
    </div>
  </div>
  